/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_Reconnect_RequiredInputs */

const en_dropbox_reconnect_required = /** @type {(inputs: Dropbox_Reconnect_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening can no longer access your Dropbox. Reconnect Dropbox to continue.`)
};

const es_dropbox_reconnect_required = /** @type {(inputs: Dropbox_Reconnect_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening ya no puede acceder a tu Dropbox. Vuelve a conectar Dropbox para continuar.`)
};

/**
* | output |
* | --- |
* | "Listening can no longer access your Dropbox. Reconnect Dropbox to continue." |
*
* @param {Dropbox_Reconnect_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_reconnect_required = /** @type {((inputs?: Dropbox_Reconnect_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_Reconnect_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_reconnect_required(inputs)
	return en_dropbox_reconnect_required(inputs)
});